import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const Faqs = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h1>Frequently Asked Questions (FAQs) – Samriddhi India</h1>

                <h4>1. What is Samriddhi India known for?</h4>
                <p>Samriddhi India is one of the best ethnic wear brands in India, offering a wide range of kurtas for women, ethnic sets, and trendy office wear. Our brand motto is “Beyond the Trend”, and we focus on creating designs that blend traditional Indian styles with modern fashion trends.</p>

                <h4>2. Where can I find Samriddhi India stores?</h4>
                <p>You can visit Samriddhi India stores inside Pacific Malls across India, making it easy for customers in major cities to shop their favorite styles. For customers who prefer shopping from home, our full collection is available online with delivery across India.</p>

                <h4>3. Do you ship across India?</h4>
                <p>Yes! We offer pan-India delivery so you can shop the latest ethnic wear online and get it delivered right to your doorstep.</p>

                <h4>4. How can I track my order?</h4>
                <p>After placing an order, you will receive a confirmation email and SMS with your order tracking details. You can also track it anytime using the “Track Order” option on our website.</p>

                <h4>5. What is your exchange and return policy?</h4>
                <p>We offer a 7-day easy exchange and return policy on most products. Items must be unused, unwashed, with original tags and packaging. Visit our Exchange & Return Policy page for full details.</p>

                <h4>6. How do I choose the right size?</h4>
                <p>Each product page has a detailed size chart for kurtas and ethnic wear, helping you select the perfect fit. If you need more help, our customer support team is ready to guide you.</p>

                <h4>7. Do you offer Cash on Delivery (COD)?</h4>
                <p>Yes, we provide Cash on Delivery (COD) option for most pin codes. You can choose this payment method at checkout.</p>

                <h4>8. Can I get my outfit customized?</h4>
                <p>Currently, we do not offer customization. However, our latest ethnic collections are updated regularly so you can always find trendy kurtas, festive outfits, and office wear that suit your style.</p>

                <h4>9. What payment methods do you accept?</h4>
                <p>We accept credit cards, debit cards, UPI, net banking, and digital wallets, ensuring a smooth and secure checkout experience.</p>

                <h4>10. How can I contact Samriddhi India for support?</h4>
                <p>
                    Email: <Link to="mailto:care@samriddhiindia.in">care@samriddhiindia.in</Link><br />
                    Customer Care: <Link to="tel:919520782777">+91 95207 82777</Link><br />
                    Or fill out the Contact Us form on our website for quick assistance.
                </p>
            </MainBox>
            <Footer />
        </>
    );
};

export default Faqs;
